import { ReactComponent as UploadImageIcon } from '../../../Assets/Icons/imageupload.svg';
import { ReactComponent as UploadVideoIcon  } from '../../../Assets/Icons/videoupload.svg';
import { ReactComponent as LinkIcon } from '../../../Assets/Icons/link.svg';


const Toolbar = ({
    variant
}) => {
    return (         <div id="toolbar">
    <select
      className="ql-header"
      defaultValue={""}
      onChange={(e) => e.persist()}
    >
      <option value="1" />
      <option value="2" />
      <option value="3" />
      <option value="4" />
      <option value="" />
    </select>
    <span class="ql-formats">
      <button class="ql-align" value=""></button>
      <button class="ql-align" value="center"></button>
      <button class="ql-align" value="right"></button>
      <button class="ql-align" value="justify"></button>
    </span>
    <span className="ql-formats">
      <button className="ql-list" value="ordered" />
      <button className="ql-list" value="bullet" />
      <button className="ql-indent" value="-1" />
      <button className="ql-indent" value="+1" />
    </span>

    <span className="ql-formats">
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-strike" />
      <button className="ql-blockquote" />
      <select className="ql-color"></select>
    </span>

    <span className="ql-formats flex items-center justify-between">
      <button className="ql-insertImage mr-3">
        <UploadImageIcon />
      </button>
      {variant === "admin" && (
        <button className="ql-insertVideo mr-3">
          <UploadVideoIcon />
        </button>
      )}
      {/* <button className="ql-insertFile">F</button> */}
      <button className="ql-link ">
        <LinkIcon />
      </button>
      {variant === "admin" && <button className="ql-video" />}{" "}
      <button className="ql-clean" />
    </span>
  </div> );
}
 
export default Toolbar;